<app-site-nav></app-site-nav>
<main class="clrweb-error-block">
  <div class="logo-block">
    <img src="/assets/images/clarity-logo.svg" alt="clarity logo" />
  </div>
  <p class="error-code">404</p>
  <p class="error-blurb">We couldn't find the page you requested.</p>
</main>
